import { render, staticRenderFns } from "./CategoriaPerguntaEditar.vue?vue&type=template&id=d4139c42&"
import script from "./CategoriaPerguntaEditar.vue?vue&type=script&lang=js&"
export * from "./CategoriaPerguntaEditar.vue?vue&type=script&lang=js&"
import style0 from "./CategoriaPerguntaEditar.vue?vue&type=style&index=0&id=d4139c42&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports